import type { FaireProductEntity } from "../../entity_types/product";

export const p_c32whhnbq7: FaireProductEntity = {
  token: "p_c32whhnbq7",
  type: "product",
  name: "Tiger",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/cfaedfb8626b98512e79d5b9754031a06e5a5e17b347acbc18ad5c5ffc5adc95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e4415248e49d3447a8bb33f0031dcc17eb34252bd8a18b887eb1288bcdc96348.jpeg",
    "https://cdn.faire.com/fastly/a402ac56bc27accfed53cd684c0dc19c4d313d6d9e1048ebd420fce309ef97e9.jpeg",
    "https://cdn.faire.com/fastly/4ca5df42f66399af0f9ad901a7388f230012ff40d72420fccc1d5fc59d223971.jpeg"
  ],
  priceDollars: 25.5,
  description: "Geometry Yoga Towel\n\n♺ Made from post-consumer recycled materials\n\n\n\n27”x72”\n\nDesigned in California\n\n\n100% Satisfaction Guarantee\n\nNo questions asked, hassle-free returns\n\n... \n\nFinally, a yoga towel designed to keep your feet — and your practice — grounded. Our Yoga Towel has always been a customer favorite, but now we’ve made it wider and longer so it’s sure to cover your mat with ease. And with more silicone grip on the back, your towel will stay where it should, no matter how sweaty your workout gets. \n\n * 27”x72”\n\n * Ultra absorbent and fast-drying\n\n * Slip-resistant, diamond-patterned silicone underside keeps your towel in place \n * Contrast edging with convenient hang loop \n * Machine washable ",
  tags: [],
  msrpDollars: 51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:53.855Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
